import { createSlice } from "@reduxjs/toolkit";

const initialProcoFilesState = {
    uploadedFiles: [],
    filterResult: null,
}

const procofilesSlice = createSlice({
    name: 'procofiles',
    initialState: initialProcoFilesState,
    reducers: {
        setUploadedFiles(state, data) {
            state.uploadedFiles = data.payload
        },
        removeFile(state, data) {
            const index = state.uploadedFiles.findIndex(object => {
                return object.id == data.payload.id
            })

            state.uploadedFiles.splice(index, 1)
        },
        setFilterResult(state, data) {
            state.filterResult = data.payload
        },
    }
})

export const procofilesActions = procofilesSlice.actions

export default procofilesSlice.reducer